import GTL from "./GTL";
import GHS from "./GHS";

// Plans ----------------------
const CorePlans = [GTL, GHS];

export default CorePlans;
